export default __webpack_public_path__ + "static/MediaMainBannerMobile-81e5cae552efefbec86d6772c14b75c7.webp";